const schema = [
  {
    name: 'article_regions',
    displayName: 'Article Region',
    nested: false,
    systemIdField: 'id',
    displayIdField: 'value',
    deletable: true,
    tabGroup: { key: 'system_settings', label: 'System Settings' },
    createMultiple: true,
    path: '/article_regions',
    fields: [
      {
        name: 'id',
        displayName: 'ID',
        dataType: 'integer',
        required: true,
        systemIdentifier: true,
        hidden: true,
      },
      {
        name: 'name',
        displayName: 'Name',
        dataType: 'text',
        required: true,
        systemIdentifier: false,
      },
      {
        name: 'image_url',
        displayName: 'Image URL',
        dataType: 'text',
        required: true,
        systemIdentifier: false,
      },
    ],
  },
];
export default schema;
